import { ActiveUser } from "@/services/user";

export const LanguageMixin = {
  computed: {
    languages() {
      return [
        { label: "EN", value: "en" },
        { label: "FR", value: "fr" },
      ];
    },
    language() {
      return this.$store.state.language;
    },
  },
  mounted() {
    const language = ActiveUser.getLanguage();
    if (language && language !== this.language) {
      this.setLanguage(language);
    }
  },
  methods: {
    setLanguage(value) {
      this.$store.commit("set", ["language", value]);
      ActiveUser.setLanguage(value);
    },
  },
};
